import { render, staticRenderFns } from "./apolegamy_table.vue?vue&type=template&id=2fb0e488&scoped=true&"
import script from "./apolegamy_table.vue?vue&type=script&lang=js&"
export * from "./apolegamy_table.vue?vue&type=script&lang=js&"
import style0 from "./apolegamy_table.vue?vue&type=style&index=0&id=2fb0e488&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb0e488",
  null
  
)

export default component.exports